export default (value: string, separator: string): string => {
  const values = value.split(separator)
  return values?.[values?.length - 1]
}
